const DEFAULT_BRANDED_DOMAINS_TARGET = 'branded-domains.singular.net';

const BRANDED_DOMAINS_TARGET_BY_HOST = {
    'fortis.singular.net': 'branded-domains-ft.singular.net',
    'openai.singular.net': 'branded-domains-oa.singular.net',
    'wb.singular.net': 'branded-domains-wb.singular.net',
};

const getCurrentHost = () => {
    if (typeof window === 'undefined') return '';
    return window.location.hostname || window.location.host || '';
};

export function getBrandedDomainsTarget(host = getCurrentHost()) {
    const normalizedHost = host.split(':')[0];
    return BRANDED_DOMAINS_TARGET_BY_HOST[normalizedHost] || DEFAULT_BRANDED_DOMAINS_TARGET;
}

export async function getCNAMEFromDomain(domain) {
    try {
        const response = await fetch(`https://cloudflare-dns.com/dns-query?name=${domain}&type=CNAME`, {
            headers: {
                Accept: 'application/dns-json',
            },
        });

        if (!response.ok) return null;

        const data = await response.json();

        if (!data.Answer) return null;

        const cnameRecord = data.Answer.find(record => record.type === 5);

        if (!cnameRecord) return null;

        return cnameRecord.data.endsWith(`${getBrandedDomainsTarget()}.`) ? cnameRecord.data.slice(0, -1) : null;
    } catch (error) {
        console.error(`Error checking CNAME for ${domain}: ${error.message}`);
        return null;
    }
}
